export const STORE_MANAGER_ADOPTION = 'store-manager-adoption';
